import APIManager from "../utilities/apimanager";
import CookieManager from "../utilities/cookiemanager";
import logger from "../utilities/logger";
import { registerInWindow } from "../utilities/registerInWindow.util";
import language from "../dictionary";

registerInWindow("testRedeemVoucher", redeemAndStoreVoucher);
registerInWindow("testGetActiveVoucher", getVoucherEndDate);

/** @typedef {string} UTCString */

/**
 * @param {string | number} userId
 * @param {string | number} sessionId
 * @param {string} voucher
 */
export async function redeemAndStoreVoucher(userId, sessionId, voucher) {
  try {
    const response = await APIManager.redeemVoucher(userId, sessionId, voucher);
    const date = getEndDateFromResponse(response);
    storeVoucherEndDateAsCookie(date);
  } catch (error) {
    const data = createReadableVoucherErrorData(error);
    throw new Error(data.readableMessage, { cause: data.cause });
  }
}

/**
 * @param {VoucherResponseSuccess | VoucherResponseError} response
 */
function getEndDateFromResponse(response) {
  if (response.AccessEndDate) {
    return new Date(response.AccessEndDate);
  } else if (response.ReturnCode && response.ReturnMessage) {
    // The ReturnCode and ReturnMessage, sent by the BE, have misleading names:
    // - ReturnCode is a description of the error
    // - ReturnMessage is the Twipe error code
    throw new Error(response.ReturnCode, {
      cause: {
        twipeCode: response.ReturnMessage,
      },
    });
  }
  throw new Error("unknown error during voucher redemption");
}

function createReadableVoucherErrorData(error) {
  let errorCode;
  if (error.cause && error.cause.twipeCode) {
    errorCode = error.cause.twipeCode;
  }
  return {
    readableMessage: `${
      language.settings.voucher.errors[
        mapTwipeErrorCodeToTranslationKey(errorCode)
      ]
    } ${errorCode ? `(${errorCode})` : ""}`,
    cause: error.cause,
  };
}

/**
 * @param {Date} date
 */
export function storeVoucherEndDateAsCookie(date) {
  CookieManager.createCookie(
    CookieManager.cookieKeys.VOUCHER,
    date.toUTCString(),
    {
      expires: date,
    }
  );
  logger.debug(`stored voucher cookie with expiry date ${date}`);
}

export function isVoucherActive() {
  const date = getVoucherEndDate();
  return date !== undefined;
}

export function getVoucherEndDate() {
  const UTCString = CookieManager.getCookie(CookieManager.cookieKeys.VOUCHER);
  return UTCString ? new Date(UTCString) : undefined;
}

/**
 * @param {string | undefined} errorCode
 * @returns {string}
 */
export function mapTwipeErrorCodeToTranslationKey(errorCode) {
  const mapping = {
    E40: "alreadyRedeemed", // voucher has already been used up
    E41: "expired", // voucher is expired
    E42: "invalid", // voucher passed BE input validation but is not found in the DB
    E43: "invalid", // voucher did not pass BE input validation
  };
  return mapping[errorCode] || "generic";
}



// WEBPACK FOOTER //
// ./src/common/services/voucher.js